import { gql } from '@apollo/client';

export const GET_CHAT_MESSAGES = gql`
  query GetChatMessages($filter: ChatMessagesFilterInput!) {
    getChatMessages(filter: $filter) {
      items {
        chat_id
        case_id
        content
        created_by
        created_date
        id
        role
      }
    }
  }
`;
